// This method gets the error with the current error structure we are sending.
// It might get changed after this task is done:

import type { PayoutRequestErrors } from 'api';

// ATT. @dmuneras
export const getAttributeErrors = (
  errors: PayoutRequestErrors,
  section: string,
  attrName: string
) => {
  const sectionErrors = errors?.[section];

  if (sectionErrors) {
    const relevantError = sectionErrors.find(
      (error: any) => error.pointer === attrName
    );

    return relevantError ? relevantError.details : [];
  }

  return [];
};
